import React, { useState, useEffect, useRef } from "react";
import { Breadcrumb } from "../ui/breadcrumb";
import { AppSidebar } from "../ui/sidebar";
import styles from "../Styles/ui/Dashboard.module.css";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "../ui/desktopcard";
import { MdArrowRightAlt } from "react-icons/md";
import { GoDatabase } from "react-icons/go";
import { GrDatabase } from "react-icons/gr";
import { Layers } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { fetchSchema } from "../../../actions/schemaExplorer";
import { useSelector, useDispatch } from "react-redux";
import { fetchTemplates, deleteTemplate } from "../../../actions/saveTemplate";
import Header from "../../header";
import { decryptData } from "../../utils/EncriptionStore";

const TemplateItem = ({ template }) => {
  const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
  })();

  const dispatch = useDispatch();



  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editedTemplate, setEditedTemplate] = useState({ ...template });
  const templates = useSelector((state) => state.saveTemplate.templates);


const handleDelete = () => {
  dispatch(
    deleteTemplate({
      name: template, // 👈 backend expects `name`, not `template`
      customer_id: user?.customer_id,
      group_id: user?.group_id,
      customer_name: user?.customer_name,
      group_name: user?.groupname,
    })
  );
};


  return (
    <div className={styles.dashboardTemplateItem}>
      <Link
        to={`/inventory_detail?inventory_name=${template}`}
        className={styles.dashboardtemplateLink}
      >
        <span>{template}</span>
      </Link>
    </div>
  );
};

const Dashboard = () => {
  const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
  })();

  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(fetchSchema());
    dispatch(
      fetchTemplates()
    );
  }, []);

  const location = useLocation();
  const hasTriggeredReloadRef = useRef(false);
  useEffect(() => {
    const key = `refreshedOnce:${location.pathname}`;

    if (!hasTriggeredReloadRef.current && !sessionStorage.getItem(key)) {
      hasTriggeredReloadRef.current = true;
      sessionStorage.setItem(key, "1");
      window.location.reload();
    }
    return () => {
      sessionStorage.removeItem(key);
    };
  }, [location.pathname]);


  const templates = useSelector((state) => state?.saveTemplate?.templates);

  const schemasFromStore = useSelector(
    (state) => state?.schemaExplorer?.schemas
  );

  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => setIsOpen((prev) => !prev);

  const parent = true;

  return (
    <div className={styles.dashboardGrid}>
      <div className={styles.twoSidebars}>
        <Header />
        <div
          className={` ${isOpen ? styles.sidebarOpen : styles.sidebarClosed}`}
        >
          <AppSidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
        </div>
      </div>
      <div className={styles.dashboardLayout}>
        {/* Sidebar wrapper: group both sidebars here if needed */}

        {/* Main content */}
        <div className={styles.mainContent}>
          <h1 className={styles.mainHeading}>Dashboard</h1>
          <p>Welcome to your database inventory management system.</p>

          <div className={styles.cardContainer}>
            <Card>
              <CardHeader>
                <CardTitle>Recent Inventories (Top 7)</CardTitle>
                <CardDescription>
                  Your recently created inventories
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ul>
                  {Array.isArray(templates) && templates.length > 0 ? (
                    <>
                      {templates.slice(0, 7).map((template) => (
                        <TemplateItem key={template} template={template} />
                      ))}
                      <li className={styles.dashboardFooter}>
                        <Link to="/inventory_builder">
                          Build Inventory{" "}
                          <i>
                            <MdArrowRightAlt />
                          </i>
                        </Link>
                      </li>
                    </>
                  ) : (
                    <p className={styles.emptyState}>No Templates Available</p>
                  )}
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Recent Schemas (Top 7)</CardTitle>
                <CardDescription>
                  Your recent available database schemas
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ul>
                  {Array.isArray(schemasFromStore) &&
                    schemasFromStore.slice(0, 7).map((schema, index) => (
                      <li key={index}>
                        <strong>{schema}</strong>
                      </li>
                    ))}
                  <li className={styles.dashboardFooter}>
                    <Link to="/schema_explorer">
                      Explore Schemas{" "}
                      <i>
                        <MdArrowRightAlt />
                      </i>
                    </Link>
                  </li>
                </ul>
              </CardContent>
            </Card>

            <Card className={styles.quickActionsCard}>
              <CardHeader>
                <CardTitle>Quick Actions</CardTitle>
                <CardDescription>Manage Inventories</CardDescription>
              </CardHeader>
              <CardContent>
                <ul className={styles.quickActionsList}>
                  <li>
                    <Link
                      className={styles.quickActionsLink}
                      to="/add_connection"
                    >
                      <i className={styles.quickActionsIcon}>
                        <GoDatabase />
                      </i>
                      <p className={styles.quickActionsText}>New Connection</p>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={styles.quickActionsLink}
                      to="/schema_explorer"
                    >
                      <i className={styles.quickActionsIcon}>
                        <GrDatabase />
                      </i>
                      <p className={styles.quickActionsText}>Explore Schema</p>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={styles.quickActionsLink}
                      to="/inventory_builder"
                    >
                      <i className={styles.quickActionsIcon}>
                        <Layers />
                      </i>
                      <p className={styles.quickActionsText}>Build Inventory</p>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={styles.quickActionsLink}
                      to="/inventory_management"
                    >
                      <i className={styles.quickActionsIcon}>
                        <Layers />
                      </i>
                      <p className={styles.quickActionsText}>
                        Manage Inventories
                      </p>
                    </Link>
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
